import * as loadQueueHelper from '../../document/load-queue'
import initDocumentWidgetsFromAPI from './widget'

loadQueueHelper.add(function () {
  initDocumentWidgetsFromAPI()
}, 2)
